import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadStopsListBegin, loadStopsListFailed, loadStopsListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_MDS_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY, MOCK_MDS_URL,
} from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadStopsList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    // const url = `${MOCK_MDS_URL}/agency/vehicles/stops`;
    const url = `${BACKEND_MDS_URL}/agency/vehicles/stops`;
    yield put(loadStopsListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.data) {
      yield put(loadStopsListSuccessful(data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadStopsListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadStopsListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
